/* eslint-disable no-nested-ternary */
import { Buffer } from 'buffer';
import { useEffect, useState } from 'react';
import { META_COLLECT_API } from '../../api';
import { useSigninContext } from '../../context/AuthProviderPages/Signin';
import { CollectRegister } from '../../types/CollectRegister';
import { Statistic } from '../../types/Statistic';
import { StopedCollectRegister } from '../../types/StopedCollectRegister';
import { formatDate } from '../../utils/date/formatDate';
import { formatReceiveSeconds } from '../../utils/formatReceiveSeconds';
import { returnRegisterType } from '../../utils/returnRegisterType';
import { DontExistsItem } from '../DontExistsItem';
import { DontExistsItemFlex } from '../DontExistsItem/styles';
import { LoadingData } from '../LoadingData';
import { renderIcon } from './renderIcon';
import {
  CardOdometerContaner,
  ContainerStatisticsTimeLine,
  MouthCollectionItem,
  MouthContainer,
  MouthDischargeItem,
  MouthHeader,
  MouthTemperature,
  TimeLineCard,
  TimeLineCurrentTime,
  TimeLineSpace,
  TimeLineSpaceContainer,
} from './styles';

interface IStatisticsTimeLine {
  statistics: Statistic[];
  loading: boolean;
}

interface ICardSpace {
  index: number;
  statistics: Statistic[];
}

const CardSpace = ({ index, statistics }: ICardSpace) => {
  const isRender = index < statistics.length - 1;
  return isRender ? (
    <TimeLineSpaceContainer>
      <TimeLineSpace />
      <TimeLineCurrentTime>
        <span>{statistics[index].DFDIFERENCAEMSEGUNDOS}</span>
      </TimeLineCurrentTime>
    </TimeLineSpaceContainer>
  ) : (
    <></>
  );
};

const CardImage = ({ DFTIPOREGISTRO, DFIDREGISTRO }: CollectRegister) => {
  if (['1', '2'].includes(DFTIPOREGISTRO)) {
    const [image, setImage] = useState();
    const { path } = useSigninContext();
    const getImage = async () => {
      META_COLLECT_API.get(`/itemregistro?DFIDREGISTRO=${DFIDREGISTRO}`, {
        headers: {
          path,
        },
      }).then(response => {
        if (response.data.itens.length > 0) {
          const buffer =
            response.data.itens[0] &&
            Buffer.from(
              response.data.itens[0].DFREGISTROIMAGEM!.data,
            ).toString();
          setImage(buffer);
        }
      });
    };
    useEffect(() => {
      getImage();
    }, []);
    return (
      <CardOdometerContaner>
        <img src={`data:image/jpeg;base64,${image}`} alt="Image de Odômetro" />
      </CardOdometerContaner>
    );
  }
  return null;
};

const StatisticsTimeLine = ({ statistics, loading }: IStatisticsTimeLine) => {
  const renderTimeLine = () => {
    return statistics.map((item, index) => {
      const { DFTIPO } = item;
      let current;
      if (DFTIPO === 'R') {
        current = item as CollectRegister;
        const {
          DFTIPOREGISTRO,
          DFTIPOITEMCOLETA,
          DFOBSERVACAO,
          DFDESCTANQUE,
          DFQTDCOLETADA,
          DFTEMPERATURA,
          DFDATAREGISTRO,
          DFHORAREGISTRO,
          DFHORACOLETA,
        } = current;
        const isDescarga = DFTIPOREGISTRO === 'D';
        const mouthsFiltered =
          current.BOCASARMAZENADAS?.filter(boca => Number(boca.DFVOLUME) > 0) ||
          [];

        return (
          <div key={current.DFIDREGISTRO}>
            <TimeLineCard
              DFTIPOREGISTRO={DFTIPOREGISTRO!}
              DFTIPOITEMCOLETA={DFTIPOITEMCOLETA}
            >
              <div className="icon">
                <img src={renderIcon(DFTIPOREGISTRO!)} />
              </div>
              <div className="card-column">
                <span>
                  {returnRegisterType(DFTIPOREGISTRO, DFTIPOITEMCOLETA)}
                </span>
                <p>
                  <b>Observação: </b>
                  {DFOBSERVACAO || 'Não informada'}
                </p>
                {DFDESCTANQUE && (
                  <p>
                    <b>Tanque:</b> {DFDESCTANQUE}
                  </p>
                )}
                {DFTIPOREGISTRO !== 'O' && (
                  <>
                    {DFQTDCOLETADA && (
                      <p>
                        <b>Volume:</b> {DFQTDCOLETADA}L
                      </p>
                    )}
                    {DFTEMPERATURA && (
                      <p>
                        <b>Temperatura:</b> {DFTEMPERATURA}°
                      </p>
                    )}

                    {mouthsFiltered.length > 0 && (
                      <MouthContainer isDescarga={isDescarga}>
                        <MouthHeader>
                          <b>
                            {isDescarga
                              ? 'Dados de Armazenamento:'
                              : 'Armazenamento por Boca:'}
                          </b>
                        </MouthHeader>
                        {mouthsFiltered.map((boca, idx) =>
                          isDescarga ? (
                            <MouthDischargeItem
                              key={`${boca.DFBOCA}-${
                                boca.DFIDSILO ?? ''
                              }-${idx}`}
                            >
                              <p>
                                <b>Boca:</b> {boca.DFBOCA} | <b>Volume:</b>{' '}
                                {boca.DFVOLUME}L
                              </p>
                              {boca.DFDESCRICAOSILO && (
                                <>
                                  <p>
                                    <b>Silo:</b>
                                    {boca.DFDESCRICAOSILO}
                                  </p>
                                  {boca.DFTEMPERATURA && (
                                    <MouthTemperature>
                                      Temp: {boca.DFTEMPERATURA}°
                                    </MouthTemperature>
                                  )}
                                </>
                              )}
                            </MouthDischargeItem>
                          ) : (
                            <MouthCollectionItem
                              key={`${boca.DFBOCA}-${
                                boca.DFIDSILO ?? ''
                              }-${idx}`}
                            >
                              • Boca {boca.DFBOCA}: {boca.DFVOLUME}L
                            </MouthCollectionItem>
                          ),
                        )}
                      </MouthContainer>
                    )}
                  </>
                )}
                {DFDATAREGISTRO && (
                  <p>
                    <b>Data e Hora:</b> {formatDate(DFDATAREGISTRO)}
                    &nbsp; às {DFHORACOLETA || DFHORAREGISTRO || '-'}
                  </p>
                )}
              </div>
            </TimeLineCard>
            <CardImage {...current} />
            <CardSpace {...{ index, statistics }} />
          </div>
        );
      }
      current = item as StopedCollectRegister;
      const {
        DFFIMDATAPARADA,
        DFFIMHORAPARADA,
        DFINICIODATAPARADA,
        DFINICIOHORAPARADA,
        DFSEGUNDOSPARADO,
      } = current;
      return (
        <div key={`P-${DFINICIODATAPARADA}-${DFINICIOHORAPARADA}`}>
          <TimeLineCard DFTIPOREGISTRO={'P'}>
            <div className="icon">
              <img src={renderIcon('P')} />
            </div>
            <div className="card-column">
              <span>{returnRegisterType('P', undefined)}</span>
              <p>
                <b>Observação: </b> Carreteiro ficou parado entre {`\n`}
                <b>
                  {formatDate(DFINICIODATAPARADA)} às{' '}
                  {DFINICIOHORAPARADA || '-'}
                </b>
                <a> e </a>
                <b>
                  {formatDate(DFFIMDATAPARADA)} às {DFFIMHORAPARADA || '-'}
                </b>
                <a> durante {formatReceiveSeconds(DFSEGUNDOSPARADO)}</a>
              </p>
            </div>
          </TimeLineCard>
          <CardSpace {...{ index, statistics }} />
        </div>
      );
    });
  };

  return (
    <ContainerStatisticsTimeLine
      style={{
        alignItems: `${loading ? 'center' : 'normal'}`,
        justifyContent: `${loading ? 'center' : 'normal'}`,
      }}
    >
      {loading === true ? (
        <LoadingData title="Carregando dados!" />
      ) : statistics.length > 0 && loading === false ? (
        <>{renderTimeLine()}</>
      ) : (
        loading === false &&
        statistics.length === 0 && (
          <DontExistsItemFlex>
            <DontExistsItem title="Nenhum item foi encontrado!" />
          </DontExistsItemFlex>
        )
      )}
    </ContainerStatisticsTimeLine>
  );
};

export { StatisticsTimeLine };
